<template>
    <common-modal
        height="small"
        width="extra-large"
        @emitEvent="emitEvent($event, ['close'])"
        @close="emitEvent({ name: 'close' })"
    >
        <common-loader v-if="isProcessing" :isProcessing="isProcessing"></common-loader>
        <div v-else class="avaiable-locations">
            <common-content-spacer height="medium">
                <common-page-header :heading="'Please choose location'"></common-page-header>
                <availability-locations
                    v-if="locations.length"
                    :hoverTitle="$t('pages.profile.professional.availability.check')"
                    :maxNumberOfItems="maxNumberOfItems"
                    :locations="locations"
                    @go-to-location="goToTimeProposal($event)"
                ></availability-locations>
            </common-content-spacer>
        </div>
    </common-modal>
</template>

<script>
    import ReferralsPoolAPI from 'api/ReferralsPoolAPI'
    import AvailabilityLocations from 'components/page-elements/profile/AvailabilityLocations'
    import dayjs from 'dayjs'

    export default {
        components: { AvailabilityLocations },

        props: {
            searchBy: { type: Object, required: true },
            referral: { type: Object, required: true },
        },

        data() {
            return {
                locations: [],
                isProcessing: false,
            }
        },

        computed: {
            maxNumberOfItems() {
                if (this.isTablet) {
                    return 1
                }
                if (this.isLaptop) {
                    return 2
                }

                return 3
            },
        },

        methods: {
            getReferralPoolProviders() {
                this.isProcessing = true
                const query = {
                    address: this.searchBy.address || undefined,
                    city: this.searchBy.city || undefined,
                    state: this.searchBy.state || undefined,
                    zip: this.searchBy.zip,
                    patientId: this.referral.patientId,
                }
                ReferralsPoolAPI.getAvailableLocations(this.$auth.getActiveMember().id, query)
                    .then((response) => {
                        this.locations = response
                    })
                    .finally(() => {
                        this.isProcessing = false
                    })
            },

            goToTimeProposal(event) {
                this.$router.push({
                    name: `pool.propose.time`,
                    params: {
                        poolId: this.$route.params.id,
                        locationId: event.practiceLocationId,
                    },
                    query: {
                        physicianId: this.$auth.getActiveMember()?.id
                            ? this.$auth.getActiveMember()?.id
                            : this.$auth.getUser().id,
                        practiceId: this.$auth.getPractice().id,
                        userId: this.$auth.getActiveMember()?.id ? this.$auth.getActiveMember()?.id : this.$auth.getUser().id,
                        practiceLocationId: event.practiceLocationId,
                        fromUserId: this.referral?.fromUser?.id,
                        timeFrame: this.referral?.timeframe,
                        fromDate: dayjs(this.referral?.createdAt).format('YYYY-MM-DD'),
                        distance: event.distance ?? undefined,
                    },
                })
            },
        },

        mounted() {
            this.getReferralPoolProviders()
        },
    }
</script>

<style scoped lang="scss">
    .content {
        max-height: 500px;
        overflow-y: auto;
    }

    .providers-list {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 10px 10px;
        overflow-x: hidden;
    }
</style>
